import { render, staticRenderFns } from "./JobTable.vue?vue&type=template&id=a9b2bfce&scoped=true"
import script from "./JobTable.vue?vue&type=script&lang=ts"
export * from "./JobTable.vue?vue&type=script&lang=ts"
import style0 from "./JobTable.scss?vue&type=style&index=0&id=a9b2bfce&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b2bfce",
  null
  
)

export default component.exports